module.exports = __webpack_public_path__ + "static/media/technical-parameters-blurred.c6b59c36.png";